<div class="card dialog-card">
  <div class="card-header">
    <h3 class="header-title">
      {{ "administration.removeMember.title" | translate }}
    </h3>

    <button type="button" class="close-button" (click)="dialogRef.close(false)" [attr.aria-label]="'common.close' | translate">
      <lucide-angular name="x" [size]="20"></lucide-angular>
    </button>
  </div>

  <div class="card-content">
    <p class="dialog-message">
      {{ "administration.removeMember.message" | translate: { email: data.member.email } }}
    </p>

    <div class="error-message" *ngIf="errorCode">
      <span>{{ "administration.memberManagement.error." + errorCode | translate }}</span>
    </div>

    <!-- Actions -->
    <div class="form-actions">
      <button class="button-secondary" type="button" (click)="dialogRef.close(false)">
        {{ "button.cancel" | translate }}
      </button>

      <button class="button-danger" type="button" [disabled]="isRemoving" (click)="confirm()">
        {{ "button.remove" | translate }}
      </button>
    </div>
  </div>
</div>
